import { render, staticRenderFns } from "./ThanksES.vue?vue&type=template&id=55c15a6e&scoped=true&"
import script from "./ThanksES.vue?vue&type=script&lang=js&"
export * from "./ThanksES.vue?vue&type=script&lang=js&"
import style0 from "./ThanksES.vue?vue&type=style&index=0&id=55c15a6e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c15a6e",
  null
  
)

export default component.exports